// @flow
import React, { PureComponent } from 'react'
import Utils from 'live/lib/utils'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import ReactDOM from 'react-dom'
import Modal from 'live/components/ui/Modal'
import SitopComment from './sitopComment'

class SitopCommentService {

    rendered = false
    root: ?HTMLElement

    constructor (url: string) {
        this.root = document.createElement('div')

        document.body.appendChild(this.root)

        window.Live.openSitopComment = this.showSitopComment
    }

    showSitopComment = sitopComment => {
        ReactDOM.render(<SitopCommentModal onHide={this.onHide} sitopComment={sitopComment} />, this.root)
    }

    onHide = a => {
        this.rendered = false
        ReactDOM.unmountComponentAtNode(this.root)
    }

}

const sitopCommentService = new SitopCommentService()

export default sitopCommentService

class SitopCommentModal extends PureComponent {

    state = {
        edit: false
    }

    submitFn = console.warn.bind(null, 'No submit function lifted.')

    onEdit = (event, form) => {
        this.setState({
            edit: true,
            FormComponent: form.component,
            editingEvent: { ...this.props.sitopComment }
        })
    }

    renderEdit = () => {
        const { FormComponent, editingEvent } = this.state

        return (
            <FormComponent
                onHide={sitopComment => {
                    this.setState({
                        sitopComment: sitopComment && sitopComment.uid ? sitopComment : null,
                        edit: false
                    })
                }}
                liftSubmitFn={fn => (this.submitFn = fn)}
                event={editingEvent}
                showActions={true}
            />
        )
    }

    renderView = () => {
        return (
            <SitopComment
                onDelete={this.props.onHide}
                expanded={true}
                event={this.state.sitopComment || this.props.sitopComment}
                onEdit={this.onEdit}
                onHide={this.props.onHide}
            />
        )
    }

    render () {
        const { edit } = this.state
        const { onHide } = this.props

        return (
            <Modal backdrop="static" keyboard={false} onHide={onHide} show={true}>
                <React.Fragment>{edit ? this.renderEdit() : this.renderView()}</React.Fragment>
            </Modal>
        )
    }

}
